import { render, staticRenderFns } from "./UnitLosListItem.vue?vue&type=template&id=5f130ec8&scoped=true&"
import script from "./UnitLosListItem.vue?vue&type=script&lang=js&"
export * from "./UnitLosListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f130ec8",
  null
  
)

export default component.exports